import React from 'react';
import './hqi.css';
import HQIBanner from '../../assets/images/hqiBanner.svg';
import CameraImg from '../../assets/images/camera.svg';
import Imgone from '../../assets/images/img 1.svg';
import PhoneImg from '../../assets/images/hqiPhone.svg';
import Banner from '../../assets/images/banner3.svg';

import BG from '../../assets/images/BG.svg';

import Icon1 from '../../assets/images/Icon 1.svg';
import Icon2 from '../../assets/images/Icon 2.svg';
import Icon3 from '../../assets/images/Icon 3.svg';
import Icon4 from '../../assets/images/Icon 4.svg';
import Icon5 from '../../assets/images/Icon 5.svg';

import Icon6 from '../../assets/images/Icon 6.svg';

import Icon7 from '../../assets/images/Icon 7.svg';
import Icon8 from '../../assets/images/Icon 8.svg';
import Icon9 from '../../assets/images/Icon 9.svg';

import Icon10 from '../../assets/images/Icon 10.svg';
import Icon11 from '../../assets/images/Icon 11.svg';
import Icon12 from '../../assets/images/Icon 12.svg';
import Icon13 from '../../assets/images/Icon 13.svg';
import Icon14 from '../../assets/images/Icon 14.svg';
import Icon15 from '../../assets/images/Icon 15.svg';

import { REACT_APP_CAD_URL } from '../../common/components/utils/constants';

const HeartQualityIndexPage: React.FC = () => {
  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const handleGoToHepServiceClick = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (!isMobileDevice()) {
      e.preventDefault();
      alert('Kindly use your mobile device to register or sign in.');
    } else {
      window.location.href = REACT_APP_CAD_URL; 
    }
  };

  return (
    <>
      <section
        id="home"
        className="hqi-hero"
        style={{ backgroundImage: `url(${HQIBanner})` }}
      >
        <div className="container">
          <div className="hero-content">
            <h1>Heart Quality Index:</h1>
            <h2>Smartest way to measure your heart's strength</h2>
            <p>
              Easy to track, personalized, and designed to help you stay in
              control of your heart health.
            </p>
            <button
              type="button"
              onClick={handleGoToHepServiceClick}
              data-testid="cta-hero-measure"
            >
              Measure your HQI
            </button>
          </div>
        </div>
      </section>

      <section className="hqi-intro max-width-layout">
        <div className="grid-2">
          <img src={Imgone} alt="Person using HQI" className="hqi-img" />
          <div>
            <h2>Heart Quality Index</h2>
            <p>
              HQI is a measure of your heart’s resilience and <br />
              cardiovascular health. Establish your baseline and <br />
              take control of your heart health. The non-invasive, <br />
              non-intrusive, and affordable test is easily accessible <br />
              on your smartphone.
            </p>
          </div>
        </div>
      </section>

      <section
        className="hqi-factors max-width-layout"
        style={{ backgroundImage: `url(${BG})`, backgroundSize: 'cover' }}
      >
        <h3>Factors determining your heart’s strength</h3>
        <div className="hqi-factors-grid">
          <div className="factor-item">
            <img src={Icon1} alt="Heart Efficiency" />
            <span>Heart Efficiency</span>
          </div>
          <div className="factor-item">
            <img src={Icon2} alt="Heart Energy" />
            <span>Heart Energy</span>
          </div>
          <div className="factor-item">
            <img src={Icon3} alt="Heart Stability" />
            <span>Heart Stability</span>
          </div>
          <div className="factor-item">
            <img src={Icon4} alt="Heart Productivity" />
            <span>Heart Productivity</span>
          </div>
          <div className="factor-item">
            <img src={Icon5} alt="Heart’s Maximum Potential" />
            <span>Heart’s Maximum Potential</span>
          </div>
        </div>
      </section>

      <section className="hqi-measure max-width-layout">
        <div className="grid-2">
          <div>
            <h3>
              Measure your
              <br />
              Heart Quality Index on your smartphone:
            </h3>
            <ul className="measure-list">
              <li className="list-item">
                Put the finger on your smartphone camera to scan.
              </li>
              <li className="list-item">
                Take three scans to get results of HQI.
              </li>
              <li className="list-item">
                Ensure the scans are taken within 72 hours to capture your
                heart’s strength at different times.
              </li>
            </ul>
            <button
              type="button"
              onClick={handleGoToHepServiceClick}
              data-testid="cta-start-journey"
            >
              Start your journey
            </button>
          </div>
          <img src={CameraImg} alt="Scanning on phone" className="hqi-img" />
        </div>
      </section>

      <section
        className="hqi-persona max-width-layout"
        style={{ backgroundImage: `url(${BG})`, backgroundSize: 'cover' }}
      >
        <h3>Your Health Persona</h3>
        <div className="hqi-persona-grid">
          <div className="hqi-card">
            <div className="card-header">
              <img
                src={Icon6}
                alt="Tushar's Heart Profile"
                className="card-icon"
              />
              <div className="card-title">
                <h4>Tushar's Heart Profile</h4>
                <p className="age-score">Age: 34 | HQI Score: 314/500</p>
              </div>
            </div>

            <h4>Cardiovascular Strengths</h4>
            <ul className="card-list">
              <li>Excellent heart rate recovery</li>
              <li>Strong endurance capacity</li>
              <li>Above-average circulation efficiency</li>
            </ul>

            <h4>Population Standing</h4>
            <p>Top 15% in your age group</p>
          </div>

          <div className="hqi-phone">
            <img src={PhoneImg} alt="Persona phone" />
          </div>

          <div className="persona-icons">
            <div className="persona-icon">
              <img src={Icon7} alt="Personal Strengths" />
              <div>
                <strong>Personal Strengths</strong>
                <p>
                  Discover your unique cardiovascular <br />
                  capabilities and understand what <br />
                  makes your heart special.
                </p>
              </div>
            </div>
            <div className="persona-icon">
              <img src={Icon8} alt="Population Context" />
              <div>
                <strong>Population Context</strong>
                <p>
                  See how your heart health compares <br />
                  to others in your age group and <br />
                  demographic.
                </p>
              </div>
            </div>
            <div className="persona-icon">
              <img src={Icon9} alt="Detailed Analytics" />
              <div>
                <strong>Detailed Analytics</strong>
                <p>
                  Get comprehensive insights into your <br />
                  cardiovascular performance and <br />
                  potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hqi-why max-width-layout">
        <h3>Why is it the need for the hour?</h3>
        <div className="hqi-why-grid">
          <div className="why-item">
            <img src={Icon10} alt="Comprehensive analysis" />
            <strong>
              Comprehensive <br /> analysis
            </strong>
            <p>
              Test energy efficiency,
               stability, max potential and productivity of your
              heart
            </p>
          </div>
          <div className="why-item">
            <img src={Icon11} alt="Early warning heads-up" />
            <strong>
              Early warning <br />
              heads-up
            </strong>
            <p>
              Detect potential issues before
              they become serious medical 
              problems
            </p>
          </div>
          <div className="why-item">
            <img src={Icon12} alt="Lifestyle impact tracker" />
            <strong>
              Lifestyle impact <br />
              tracker
            </strong>
            <p>
              See how your daily habits 
              affect your heart health over 
              time
            </p>
          </div>
          <div className="why-item">
            <img src={Icon13} alt="Beyond heart health" />
            <strong>
              Beyond heart <br />
              health
            </strong>
            <p>
              Helps indicate risk for diabetes, 
              hypertension, and other 
              conditions
            </p>
          </div>
          <div className="why-item">
            <img src={Icon14} alt="Regular monitoring" />
            <strong>
              Regular <br />
              monitoring
            </strong>
            <p>
              No expensive clinical tests or 
              doctor visits required
            </p>
          </div>
          <div className="why-item">
            <img src={Icon15} alt="Convenient & Affordable" />
            <strong>
              Convenient <br />& Affordable
            </strong>
            <p>
              Compare results every few 
              months to stay on top of your 
              health
            </p>
          </div>
        </div>
      </section>

      <section
        className="hqi-final max-width-layout"
        style={{ backgroundImage: `url(${Banner})` }}
      >
        <div className="center-content">
          <h3>
            Ready to Know Your
            <br />
            Heart Quality Index?
          </h3>
          <button
            type="button"
            onClick={handleGoToHepServiceClick}
            data-testid="cta-footer-measure"
          >
            Measure your HQI
          </button>
        </div>
      </section>
    </>
  );
};

export default HeartQualityIndexPage;
